import { Shield } from "lucide-react";
import { Trans } from "@lingui/macro";

export function Footer() {
  return (
    <footer className="border-t border-slate-200 bg-white/60 backdrop-blur-sm">
      <div className="flex items-center justify-center gap-2 px-4 py-2 text-xs text-slate-500">
        <Shield className="h-3.5 w-3.5 text-slate-400 flex-shrink-0" />
        <span>
          <Trans>
            Données hébergées en France sur OVHcloud — infrastructure certifiée
            HDS et ISO 27001
          </Trans>
        </span>
      </div>
    </footer>
  );
}
